import { createContext, useContext, useState, useEffect } from 'react';
import moment from 'moment';

const AlbumFiltersContext = createContext();

const currentYear = moment().year();

const defaultFilters = {
  needsAListen: false,
  needsACleanin: false,
  flagsOperator: 'and',
  sortBy: 'random',
  yearFrom: 0,
  yearTo: currentYear,
  selectedGenres: [],
  selectedArtists: [],
  selectedLabels: [],
  removeDuplicates: false,
  showOnlyDuplicates: false,
  ratingRange: [1, 5],
};

export const AlbumFiltersProvider = ({ children }) => {
  const savedFilters = JSON.parse(localStorage.getItem('albumFilters'));
  const [filters, setFilters] = useState(savedFilters || defaultFilters);

  const updateFilters = (newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  };

  const clearFilters = () => {
    setFilters(defaultFilters);
    localStorage.removeItem('albumFilters');
  };

  useEffect(() => {
    localStorage.setItem('albumFilters', JSON.stringify(filters));
  }, [filters]);

  return (
    <AlbumFiltersContext.Provider value={{ filters, updateFilters, clearFilters }}>
      {children}
    </AlbumFiltersContext.Provider>
  );
};

export const useFilters = () => useContext(AlbumFiltersContext);
